import { Swiper, SwiperSlide } from "swiper/react";
import { PROXY_SERVER_GET_HOME_BANNER_BY_ID } from "../../_proxy";
import { API_V2_HOME_BANNERS_GET_BANNER_LIST } from "../../api/v2/routes/HomeBanners";
import { useEffect, useState } from "react";
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { utils_isLocalLink } from "../../components/utils/utils_isLocalLink";
import { useNavigate } from "react-router-dom";

export const ViewHomeBannerList = () => {
    const [state, setState] = useState(false);
    const [homeBannerList, setHomeBannerList] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        if (!state) {
            setState(true);
            return;
        }

        (async () => {
            const id_local = 1;
            const homeBannerList = await API_V2_HOME_BANNERS_GET_BANNER_LIST(id_local);
            const itens = [];
            for (let i = 0; i < homeBannerList?.length; i++) {
                const id = homeBannerList[i].id ?? null;
                const onClick = homeBannerList[i].onclick_url ?? null;
                if (!id) continue;
                itens.push({
                    img: PROXY_SERVER_GET_HOME_BANNER_BY_ID(id),
                    onClick
                })
            }
            setHomeBannerList(itens);
        })();

    }, [state])

    return homeBannerList && homeBannerList.length && <section>
        <Swiper
            modules={[Autoplay, Pagination, Navigation]} // Adiciona Navigation aqui
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            navigation={true}
            loop={true}
        >
            {homeBannerList?.map?.((card, index) => {
                //card_anuncio vindo do styles automaticamente
                return <SwiperSlide key={index}>
                    <div className="card_anuncio">
                        <img
                            src={card.img}
                            alt={`Slide ${index + 1}`}
                            loading='lazy'
                            width={1920}
                            height={830}
                            onClick={() => {
                                if (!card.onClick) { return }
                                const onclick_is_url = card.onClick !== null && typeof card.onClick === 'string';
                                if (onclick_is_url) {
                                    //abrindo link
                                    const link2Open =
                                        card.onClick.replaceAll('https://tonomercado.com.br/site/', '')
                                            .replaceAll('https://toome.com.br/site/', '')
                                            .replaceAll('https://app.toome.com.br/site/', '');
                                    if (utils_isLocalLink(link2Open)) {
                                        navigate(link2Open.replaceAll('app', '').replaceAll('#', 'app/#'))
                                    } else {
                                        window.open(link2Open)
                                    }
                                } else {
                                    card.onClick();
                                }
                            }}
                        />
                    </div>
                </SwiperSlide>
            })}
        </Swiper>
    </section>
}